import { render, staticRenderFns } from "./ledgerElectricityFee.vue?vue&type=template&id=3bdebd4c&scoped=true"
import script from "./ledgerElectricityFee.vue?vue&type=script&lang=js"
export * from "./ledgerElectricityFee.vue?vue&type=script&lang=js"
import style0 from "./ledgerElectricityFee.vue?vue&type=style&index=0&id=3bdebd4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdebd4c",
  null
  
)

export default component.exports